import { ActionButton } from '../ActionButton'

interface IViewOnSiteButtonProps {
  href: string
  label?: string
  isGhost?: boolean
}

/**
 * Atalho para a ação `external` do ActionButton, mantido pelos call sites existentes.
 * Em código novo, prefira `<ActionButton action="external" href={...} />`.
 */
export function ViewOnSiteButton({ href, label = 'Ver no site', isGhost = false }: IViewOnSiteButtonProps) {
  return <ActionButton action="external" href={href} label={label} variant={isGhost ? 'outline' : 'solid'} />
}
